module.exports = __webpack_public_path__ + "static/photograph-banner-c9a92216ecebe512a2d882313532c73c.jpg";